import { Component, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { TemplateDialogButtonBase } from '../../shared/base/template-dialog-button-base';
import { Course } from '../shared/course';
import { CourseUserService } from "../shared/course-user.service";
import { UserService } from "../../users/shared/user.service";

@Component({
  selector: 'app-course-group-mail-button',
  templateUrl: './course-group-mail-button.component.html'
})
export class CourseGroupMailButtonComponent extends TemplateDialogButtonBase {

  private Emails: String = '';

  constructor(
    private refService: CourseUserService,
    private userService: UserService,
    dialog: MatDialog,
    snackBar: MatSnackBar) {
    super(dialog, snackBar);
  }

  @Input() set course(course: Course) {
    if(course){
      this.refService.readList(course.$key).subscribe(members => {
        members.map(member => {
          this.userService.readChild(member.$key).subscribe(member => {
            let email = member.email + ' ';
            this.Emails += email;
          });
        });
      });
    }
  }
}






// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-group-mail-button/course-group-mail-button.component.ts